module.exports = __webpack_public_path__ + "static/media/root-beer-explore-more.70324d71.jpg";